import {
  CREATEMESHNETWORK_SUCCESS,
  UPDATEMESHNETWORK_SUCCESS,
  FETCHMESHNETWORKS_SUCCESS,
  DELETEMESHNETWORK_SUCCESS,
  CREATEMESHAPPLICATION_SUCCESS,
  UPDATEMESHAPPLICATION_SUCCESS,
  DELETEMESHAPPLICATION_SUCCESS,
  MESHDISCOVERUNPROVISIONED_SUCCESS,
  MESHPROVISION_SUCCESS,
  MESHSET_SUCCESS,
  MESHGET_SUCCESS,
  DESCRIBEJOBEXECUTION_SUCCESS
} from "../../constants/ActionTypes";

const INIT_STATE = {
  meshNetworks: {},
  describeJobExecutionStatus: {}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCHMESHNETWORKS_SUCCESS: {
      return {
        ...state,
        meshNetworks: {
            ...state.meshNetworks,
            [action.applicationId]: action.payload.getMeshNetworks
        }
      }
    }

    case CREATEMESHNETWORK_SUCCESS: {
      return {
        ...state,
        createdMeshNetwork: action.payload
      }
    }

    case UPDATEMESHNETWORK_SUCCESS: {
      return {
        ...state,
        updatedMeshNetwork: action.payload
      }
    }

    case DELETEMESHNETWORK_SUCCESS: {

      return {
        ...state,
        deleted: action.payload,
      }
    }

    case CREATEMESHAPPLICATION_SUCCESS: {
      return {
        ...state,
        createdMeshApplication: action.payload
      }
    }

    case UPDATEMESHAPPLICATION_SUCCESS: {
      return {
        ...state,
        updatedMeshApplication: action.payload
      }
    }

    case DELETEMESHAPPLICATION_SUCCESS: {
      return {
        ...state,
        deletedMeshApplication: action.payload,
      }
    }

    case MESHDISCOVERUNPROVISIONED_SUCCESS: {
      return {
        ...state,
        meshDiscoverUnprovisionedJob: action.payload.meshDiscoverUnprovisioned,
      }
    }

    case MESHPROVISION_SUCCESS: {
      return {
        ...state,
        meshProvisionJob: action.payload.meshProvision,
      }
    }

    case MESHGET_SUCCESS: {
      return {
        ...state,
        meshGetJob: action.payload.meshGet,
      }
    }

    case MESHSET_SUCCESS: {
      return {
        ...state,
        meshSetJob: action.payload.meshSet,
      }
    }

    case DESCRIBEJOBEXECUTION_SUCCESS: {
      return {
        ...state,
        describeJobExecutionStatus: {
          ...state.describeJobExecutionStatus,
          [action.jobId]: action.payload.describeJobExecution.status
        }
      }
    }

    default:
      return {
        ...state,
        updatedMeshNetwork: false,
        updatedMeshApplication: false,
        deleted: false,
        deletedMeshApplication: false,
        meshDiscoverUnprovisionedJob: false,
        meshProvisionJob: false,
        meshGetJob: false,
        meshSetJob: false
      }
  }
}
